import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTableFilter } from '@/shared';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { GROUPPROVEEDORES } from '@/shared/interfaces';
import { useFetchGroupProveedores,useUpdateGroupProovedores } from '@/shared/actions/erp';

const returnUrlGrupoProveedores = '/compras/grupo-proveedores';

export interface GroupProovedoresPageInterface {}


const GroupProovedoresPage: React.FC<GroupProovedoresPageInterface > = () => {
    const navigate = useNavigate();
    const { globalFilter, pagination, searchTerm, onChangeFilter, setPagination } = useTableFilter();
    const { pageIndex } = pagination;

    const {
        isLoading,
        data: proveedoresRes,
        isRefetching,
    } = useFetchGroupProveedores({
        page: pageIndex + 1,
        nombre: searchTerm,
    })
    /* mutations */
    const updateProovedoresMutation = useUpdateGroupProovedores({navigate,returnUrl:returnUrlGrupoProveedores});
    /* handlers */
    const onEdit = (original: GROUPPROVEEDORES) => {
        navigate(`${returnUrlGrupoProveedores}/editar/${original.id_grupo_proveedor}`);
    };

    //columns
    const columns = useMemo<MRT_ColumnDef<GROUPPROVEEDORES>[]>(
        () => [
            {
                accessorKey: 'id_grupo_proveedor',
                header: 'ID',
                size: 129,
            },
            {
                accessorKey: 'nombre',
                header: 'Nombre',
                size: 129,
            },
            {
                accessorKey: 'descripcion',
                header: 'Descripcion',
                size: 129,
            },
            {
                accessorKey: 'estado',
                header: 'Estado',
                size: 129,
                enableColumnFilter: false,
                enableSorting: false,
                Cell: ({ row }) => (
                    <SwitchComponente
                        estadoSwitch={row.original.estado}
                        titulo={row.original.estado? 'Activo' : 'Inactivo'}
                        setEstadoSwitch={value => {
                            if (row.original.id_grupo_proveedor !== undefined) {
                                updateProovedoresMutation.mutate({
                                    id: row.original.id_grupo_proveedor,
                                    data: {...row.original, estado:value as boolean },
                                });
                            }
                        }}
                    />
                ),
            },
        ],
        []
    );
    return (
        <SingleTableBoxScene title='Lista de Grupo de Proovedores' urlRedirect={`${returnUrlGrupoProveedores}/crear`}>
            <CustomSearch
                onChange={onChangeFilter}
                value={globalFilter}
                text="proveedor por nombre comercial"
            />
            <GeneralTable<GROUPPROVEEDORES>
                columns={columns}
                data={proveedoresRes?.data?.data || []}
                isLoading={isLoading}
                isRefetching={isRefetching}
                pagination={pagination}
                onPaging={setPagination}
                onEdit={onEdit}
            />
        </SingleTableBoxScene>
     );
}
export default GroupProovedoresPage;